import * as Sentry from "@sentry/gatsby"

Sentry.init({
  dsn: "https://cf9016a5a839fcb9f3eedee73eaeb4cc@o495210.ingest.us.sentry.io/4509921157185536",
  sendDefaultPii: true
})
